// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import gift02Icon from "@/assets/icons/gift-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Gift02IconProps = Omit<IconProps, "name">;

export function Gift02Icon(props: Gift02IconProps): React.ReactNode {
  return <Icon name={gift02Icon} {...props} />;
}
